"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIGBEE_DEVICES_LIMIT = void 0;
exports.ZIGBEE_DEVICES_LIMIT = {
    lite: 1,
    plus_v2: 15,
    /** @deprecated */ pro: 0,
    pro_v2: 30,
    /** @deprecated */ premium: 0,
    premium_v2: 100,
    /** @deprecated */ ultimate: 0,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=zigbee.js.map